import { Component, OnInit, OnDestroy, Input, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormArray, FormGroup, FormControl, Validators } from '@angular/forms';

import { AlertService } from '../../services/alert.service';
import { ChallengeService } from '../../services/challenge.service';
import { ProgressIndicatorService } from '../../services/progress-indicator.service';

@Component({
    selector: 'challenge-card',
    templateUrl: './challenge-card.component.html',
    styleUrls: ['./challenge-card.component.scss']
})
export class ChallengeCardComponent implements OnInit, OnDestroy {

    @Input()
    challenge: any;

    @Output('refreshChallenges')
    refreshEventEmitter = new EventEmitter<void>();

    challengeFormGroup!: FormGroup;

    newLocaleChallengeFormGroup!: FormGroup;

    deleteChallengeVisible!: boolean;

    newLocaleChallengeVisible!: boolean;

    constructor(
        private alertService: AlertService,
        private progressIndicatorService: ProgressIndicatorService,
        private challengeService: ChallengeService,
        private formBuilder: FormBuilder
    ) {
    }

    ngOnInit() {
        this.challengeFormGroup = this.formBuilder.group({
            challengeNameInput: [{ value: this.challenge.name, disabled: false }],
            challengeTargetInput: [{ value: this.challenge.target, disabled: false }],
            challengeOrderBySelect: [{ value: this.challenge.orderBy, disabled: true }],
            challengeStartInput: [{ value: this.challenge.start, disabled: false }],
            challengeEndInput: [{ value: this.challenge.end, disabled: false }],
            challengeTypeSelect: [{ value: this.challenge.type, disabled: true }],
            challengeLimitInput: [{ value: this.challenge.limit, disabled: false }],
            challengeDetailFormArray: this.formBuilder.array(this.challenge.details.map((detail: any) => {
                return this.formBuilder.group({
                    challengeDetailLocaleInput: [{ value: detail.locale, disabled: false }],
                    challengeDetailDetailInput: [{ value: detail.detail, disabled: false }],
                });
            }))
        });
        this.newLocaleChallengeFormGroup = this.formBuilder.group({
            newLocaleChallengeLocaleInput: [null],
            newLocaleChallengeDetailInput: [null],
        });
    }

    ngOnDestroy() {
    }

    getChallengeDetailFormArray(): any {
        return this.challengeFormGroup.get('challengeDetailFormArray') as FormArray;
    }

    displayDeleteChallenge() {
        this.deleteChallengeVisible = true;
        setTimeout(() => this.deleteChallengeVisible = false, 3000);
    }

    deleteChallenge() {
        this.progressIndicatorService.progress = true;
        this.challengeService.deleteChallenge(this.challenge.id).subscribe({
            next: (value: any) => {
                console.log('ChallengeCardComponent.deleteChallenge.challengeService.deleteChallenge.value', value);
                this.progressIndicatorService.progress = false;
                this.alertService.success('Success');
                this.emitRefreshEvent();
            },
            error: (error: any) => {
                console.log('ChallengeCardComponent.deleteChallenge.challengeService.deleteChallenge.error', error);
                this.progressIndicatorService.progress = false;
                this.alertService.danger('Error');
            }
        });
    }

    uploadNewChallengeLocale() {

        let formGroup: FormGroup = this.newLocaleChallengeFormGroup;
        let locale: string = formGroup.value.newLocaleChallengeLocaleInput;
        let detail: string = formGroup.value.newLocaleChallengeDetailInput;

        this.progressIndicatorService.progress = true;
        this.challengeService.uploadNewChallengeLocale(this.challenge.id, locale, detail).subscribe({
            next: (value: any) => {
                console.log('ChallengeCardComponent.uploadNewChallengeLocale.challengeService.uploadNewChallengeLocale.value', value);
                this.progressIndicatorService.progress = false;
                this.alertService.success('Success');
                this.emitRefreshEvent();
            },
            error: (error: any) => {
                console.log('ChallengeCardComponent.uploadNewChallengeLocale.challengeService.uploadNewChallengeLocale.error', error);
                this.progressIndicatorService.progress = false;
                this.alertService.danger('Error');
            }
        });
    }

    emitRefreshEvent() {
        this.refreshEventEmitter.emit();
    }
}
